import { ActivityReason } from '@office-start/document-types';
import { useMemo } from 'react';
export function useReasonTypeIcon(reasonType) {
    return useMemo(function () {
        switch (reasonType) {
            case ActivityReason.Attachment:
                return 'AttachIcon';
            case ActivityReason.Comment:
                return 'CommentIcon';
            case ActivityReason.Default:
                return 'CompassIcon';
            case ActivityReason.Edit:
                return 'EditIcon';
            case ActivityReason.Meeting:
                return 'CalendarIcon';
            case ActivityReason.Mention:
                return 'MentionIcon';
            case ActivityReason.News:
                return 'NewsIcon';
            case ActivityReason.Open:
                return 'OpenIcon';
            case ActivityReason.Pdf:
                return 'PdfIcon';
            case ActivityReason.Share:
                return 'PeopleIcon';
            case ActivityReason.SnoozeExpiry:
                return 'SnoozeExpiryIcon';
            case ActivityReason.Task:
                return 'TaskIcon';
            case ActivityReason.Trending:
                return 'TrendingIcon';
            case ActivityReason.Video:
                return 'VideoIcon';
            default:
                return 'CompassIcon';
        }
    }, [reasonType]);
}
//# sourceMappingURL=useReasonTypeIcon.js.map